
import Image from "./Image";
import { useEffect, useRef, useState } from "react";
const TELEMATICS_LOGOS = [
    { src: "/logos/telematics/onestepgps.svg?v=white", alt: "One Step GPS" },
    { src: "/logos/telematics/zubie.svg", alt: "Zubie" },
    { src: "/logos/telematics/bouncie.svg", alt: "Bouncie" },
    { src: "/logos/telematics/moovetrax.svg", alt: "MooveTrax", invert: true },
    { src: "/logos/telematics/passtime.svg", alt: "PassTime GPS" },
];
function FlipTile({ logo, index, inView, imgClassName, }) {
    return (<span className={`tele-tile ${inView ? "tele-tile--in" : ""}`} style={{ ["--d"]: `${index * 110}ms` }}>
      <span className="tele-tile__inner">
        <span className="tele-tile__face tele-tile__cover" aria-hidden="true"/>
        <span className="tele-tile__face tele-tile__back">
          <Image src={logo.src || "/placeholder.svg"} alt={logo.alt} width={240} height={72} className={`${imgClassName} object-contain${logo.invert ? " brightness-0 invert" : ""}`}/>
        </span>
      </span>
    </span>);
}
export function TelematicsLogoCollage() {
    /* Flip the logos open exactly once, when the section first scrolls into view — regardless of
       hover. Until then the tiles rest on their blank covers (the start of the reveal). The hover
       shimmer is handled separately in CSS (group-hover/card). */
    const ref = useRef(null);
    const [inView, setInView] = useState(false);
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setInView(true);
                observer.disconnect();
            }
        }, { threshold: 0.35 });
        observer.observe(el);
        return () => observer.disconnect();
    }, []);
    return (<div ref={ref} className="relative mx-auto flex h-full min-h-[19rem] w-full max-w-[260px] flex-col items-center justify-center gap-y-10 py-2" role="img" aria-label="Integrated telematics partners: One Step GPS, Zubie, Bouncie, MooveTrax and PassTime GPS">
      {/* Two logos per row for the first four marks, PassTime spans its own full-width row. */}
      {[
            [0, 1],
            [2, 3],
        ].map((row, r) => (<div key={r} className="flex w-full items-center justify-center gap-x-6">
          {row.map((i) => (<FlipTile key={TELEMATICS_LOGOS[i].alt} logo={TELEMATICS_LOGOS[i]} index={i} inView={inView} imgClassName="h-14 w-auto max-w-full"/>))}
        </div>))}
      <FlipTile logo={TELEMATICS_LOGOS[4]} index={4} inView={inView} imgClassName="h-10 w-auto max-w-[66%]"/>
    </div>);
}
